import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { CommonTypes } from "./types";
import { ErrorResponse, UIError, InitiateCheckoutUIError } from "./errors";
import { formatAMPM, formatDate, getLocalISODateString } from "@dp/common";
import moment from "moment-timezone";

var Cart = /*#__PURE__*/function () {
  function Cart(config, axios) {
    _classCallCheck(this, Cart);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Cart, [{
    key: "updateItem",
    value: function () {
      var _updateItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _payload$itemInstruct, _payload$guestName;

        var jwtToken,
            payload,
            commonQueryParams,
            locale,
            headers,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                jwtToken = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
                payload = _args.length > 1 ? _args[1] : undefined;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                return _context.abrupt("return", this.axios.put(this.config.postfix.CART, _objectSpread(_objectSpread({}, payload), {}, {
                  skuId: payload.skuId ? payload.skuId.join(",") : "",
                  selectedIds: payload.selectedIds ? payload.selectedIds.join(",") : "",
                  configQuantity: 1,
                  itemInstructions: (_payload$itemInstruct = payload.itemInstructions) !== null && _payload$itemInstruct !== void 0 ? _payload$itemInstruct : null,
                  guestName: (_payload$guestName = payload.guestName) !== null && _payload$guestName !== void 0 ? _payload$guestName : null
                }), {
                  headers: headers,
                  params: {
                    locale: locale
                  }
                }).then(function (response) {
                  return response.data.response;
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateItem() {
        return _updateItem.apply(this, arguments);
      }

      return updateItem;
    }()
  }, {
    key: "addItem",
    value: function () {
      var _addItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _payload$itemInstruct2, _payload$guestName2;

        var jwtToken,
            payload,
            commonQueryParams,
            locale,
            headers,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                jwtToken = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;
                payload = _args2.length > 1 ? _args2[1] : undefined;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                return _context2.abrupt("return", this.axios.post(this.config.postfix.CART, _objectSpread(_objectSpread({}, payload), {}, {
                  skuId: payload.skuId ? payload.skuId.join(",") : "",
                  selectedIds: payload.selectedIds ? payload.selectedIds.join(",") : "",
                  configQuantity: 1,
                  itemInstructions: (_payload$itemInstruct2 = payload.itemInstructions) !== null && _payload$itemInstruct2 !== void 0 ? _payload$itemInstruct2 : null,
                  guestName: (_payload$guestName2 = payload.guestName) !== null && _payload$guestName2 !== void 0 ? _payload$guestName2 : null
                }), {
                  headers: headers,
                  params: {
                    locale: locale
                  }
                }).then(function (response) {
                  return response.data.response;
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addItem() {
        return _addItem.apply(this, arguments);
      }

      return addItem;
    }()
  }, {
    key: "deleteItem",
    value: function () {
      var _deleteItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var jwtToken,
            payload,
            commonQueryParams,
            locale,
            headers,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                jwtToken = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : null;
                payload = _args3.length > 1 ? _args3[1] : undefined;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                return _context3.abrupt("return", this.axios["delete"](this.config.postfix.CART, {
                  params: _objectSpread(_objectSpread({}, payload), {}, {
                    locale: locale
                  }),
                  headers: headers
                }).then(function (response) {
                  return response.data.response;
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteItem() {
        return _deleteItem.apply(this, arguments);
      }

      return deleteItem;
    }()
  }, {
    key: "initiateCheckout",
    value: function () {
      var _initiateCheckout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref) {
        var orderId, jwtToken, requestedPickupDateTime, commonQueryParams, locale, headers, payload, requestedPickupDate, requestedPickupTime;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                orderId = _ref.orderId, jwtToken = _ref.jwtToken, requestedPickupDateTime = _ref.requestedPickupDateTime;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = {};

                if (jwtToken) {
                  headers = {
                    Authorization: "Bearer ".concat(jwtToken)
                  };
                }

                payload = {
                  orderId: orderId
                };

                if (requestedPickupDateTime) {
                  requestedPickupDate = formatDate(requestedPickupDateTime);
                  requestedPickupTime = formatAMPM(requestedPickupDateTime);
                  payload["pickupDate"] = requestedPickupDate;
                  payload["pickupTime"] = requestedPickupTime;
                }

                _context4.next = 9;
                return this.axios.put(this.config.postfix.INITIATE_CHECKOUT, payload, {
                  params: {
                    locale: locale
                  },
                  headers: headers
                }).then(function (response) {
                  console.log("response", response.data);
                  return response.data.response;
                })["catch"](function (error) {
                  throw new InitiateCheckoutUIError(error);
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function initiateCheckout(_x) {
        return _initiateCheckout.apply(this, arguments);
      }

      return initiateCheckout;
    }()
  }, {
    key: "getCartDetails",
    value: function () {
      var _getCartDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload, jwtToken) {
        var headers;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                headers = {};

                if (jwtToken) {
                  headers = {
                    Authorization: "Bearer ".concat(jwtToken)
                  };
                }

                return _context5.abrupt("return", this.axios.get(this.config.postfix.CART_ORDER_DETAILS, {
                  params: {
                    orderId: payload.orderId
                  },
                  headers: headers
                }).then(function (response) {
                  var _response$data;

                  return response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.response;
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getCartDetails(_x2, _x3) {
        return _getCartDetails.apply(this, arguments);
      }

      return getCartDetails;
    }()
  }, {
    key: "applyCouponCode",
    value: function () {
      var _applyCouponCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(orderId, couponCode, jwtToken) {
        var commonQueryParams, locale, requestBody, params, headers;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                requestBody = {
                  orderId: orderId,
                  couponCode: couponCode
                };
                params = {
                  locale: locale
                };
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                return _context6.abrupt("return", this.axios.put(this.config.postfix.APPLY_COUPON, requestBody, {
                  params: params,
                  headers: headers
                }).then(function (response) {
                  return response.data.response;
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function applyCouponCode(_x4, _x5, _x6) {
        return _applyCouponCode.apply(this, arguments);
      }

      return applyCouponCode;
    }()
  }, {
    key: "parseErrors",
    value: function parseErrors(errorObj) {
      var _errorObj$response;

      var errResp = (errorObj === null || errorObj === void 0 ? void 0 : errorObj.errorResponse) || (errorObj === null || errorObj === void 0 ? void 0 : (_errorObj$response = errorObj.response) === null || _errorObj$response === void 0 ? void 0 : _errorObj$response.data);
      var faults = errResp === null || errResp === void 0 ? void 0 : errResp.fault;
      var unAvailableItems = errResp === null || errResp === void 0 ? void 0 : errResp.unavailableItems;
      var reconcileItems = errResp === null || errResp === void 0 ? void 0 : errResp.reconcileItemId;
      var formException = errResp === null || errResp === void 0 ? void 0 : errResp.form;
      var errorDescriptionJson = errResp === null || errResp === void 0 ? void 0 : errResp.errorDescriptionJson;

      if (faults || unAvailableItems || formException || reconcileItems || errorDescriptionJson) {
        return {
          faults: faults ? Array.isArray(faults) ? faults : [faults] : null,
          unAvailableItems: unAvailableItems ? Array.isArray(unAvailableItems) ? unAvailableItems : [unAvailableItems] : null,
          formException: formException ? Array.isArray(formException) ? formException : [formException] : null,
          reconcileItems: reconcileItems ? Array.isArray(reconcileItems) ? reconcileItems : [reconcileItems] : null,
          errorDescriptionJson: errorDescriptionJson !== null && errorDescriptionJson !== void 0 ? errorDescriptionJson : null
        };
      } else {
        return null;
      }
    }
  }, {
    key: "getFaultCodes",
    value: function getFaultCodes(errorObj) {
      var _errorObj$response2;

      var errResp = (errorObj === null || errorObj === void 0 ? void 0 : errorObj.errorResponse) || (errorObj === null || errorObj === void 0 ? void 0 : (_errorObj$response2 = errorObj.response) === null || _errorObj$response2 === void 0 ? void 0 : _errorObj$response2.data);
      var faults = errResp === null || errResp === void 0 ? void 0 : errResp.fault;

      if (faults) {
        if (Array.isArray(faults)) {
          return faults.map(function (fault) {
            return fault.faultCode || fault.faultDescription;
          });
        } else {
          return [faults.faultCode || faults.faultDescription];
        }
      } else {
        return [];
      }
    }
  }, {
    key: "removeCouponCode",
    value: function () {
      var _removeCouponCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(orderId, couponCode, jwtToken) {
        var commonQueryParams, locale, requestBody, params, headers;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                requestBody = {
                  orderId: orderId,
                  couponCode: couponCode
                };
                params = {
                  locale: locale
                };
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                return _context7.abrupt("return", this.axios.put(this.config.postfix.REMOVE_COUPON, requestBody, {
                  params: params,
                  headers: headers
                }).then(function (response) {
                  return response.data.response;
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function removeCouponCode(_x7, _x8, _x9) {
        return _removeCouponCode.apply(this, arguments);
      }

      return removeCouponCode;
    }()
  }, {
    key: "submitOrder",
    value: function () {
      var _submitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(submitOrderRequest, jwtToken) {
        var commonQueryParams, locale, headers;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = {};

                if (jwtToken) {
                  headers = {
                    Authorization: "Bearer ".concat(jwtToken)
                  };
                } // TODO (Payments): remove after migration
                // paymentCollection: {
                //   // eslint-disable-next-line sonarjs/no-duplicate-string
                //   "atg-rest-class-type": "java.util.ArrayList",
                //   "atg-rest-class-descriptor": {
                //     "atg-rest-values": {
                //       "container-class": "java.util.ArrayList",
                //       "element-class":
                //         "com.darden.integration.paymentservice.bean.TransactionalDetail",
                //     },
                //   },
                //   "atg-rest-values": payments.map((payment) => {
                //     if (payment.inStorePayment) {
                //       //TODO:: for cloud API use the below object
                //       /* return {
                //         inStorePayment: {
                //           amount: payment.inStorePayment.amount,
                //         },
                //       }
                //       */
                //       return {
                //         ...payment,
                //         inStorePayment: {
                //           "atg-rest-class-type":
                //             "com.darden.commerce.order.purchase.InStorePaymentBean",
                //           ...payment.inStorePayment,
                //         },
                //       };
                //     }
                //     if (payment.payPalPayment) {
                //       return {
                //         ...payment,
                //         transType: "PAYPAL_TOGO",
                //         payPalPayment: {
                //           "atg-rest-class-type":
                //             "com.darden.commerce.order.purchase.PayPalPaymentBean",
                //           ...payment.payPalPayment,
                //           type: "PAYPAL_TOGO",
                //           orderID: orderId,
                //         },
                //         authTransID: "",
                //         status: "SUCCESS",
                //         ...dfpParams,
                //       };
                //     }
                //     if (payment.applePayPayment) {
                //       const applePayPayment = payment.applePayPayment;
                //       delete payment.applePayPayment;
                //       if (applePayPayment.transcationInfo.paymentMethod.displayName) {
                //         applePayPayment.transcationInfo.paymentMethod.displayName =
                //           encodeURIComponent(
                //             applePayPayment.transcationInfo.paymentMethod.displayName,
                //           );
                //       }
                //       return {
                //         ...payment,
                //         transType: "APP",
                //         dardenDigitalWalletBean: {
                //           "atg-rest-class-type":
                //             "com.darden.commerce.order.purchase.DardenDigitalWalletBean",
                //           ...applePayPayment,
                //           sdkVersion: "EC_v1",
                //         },
                //         authTransID: "",
                //         status: "SUCCESS",
                //         ...dfpParams,
                //       };
                //     }
                //     if (payment.googlePayPayment) {
                //       const googlePayPayment = payment.googlePayPayment;
                //       delete payment.googlePayPayment;
                //       delete googlePayPayment.transcationInfo.info;
                //       if (googlePayPayment.transcationInfo.description) {
                //         googlePayPayment.transcationInfo.description =
                //           encodeURIComponent(
                //             googlePayPayment.transcationInfo.description,
                //           );
                //       }
                //       return {
                //         ...payment,
                //         transType: "GP",
                //         dardenDigitalWalletBean: {
                //           "atg-rest-class-type":
                //             "com.darden.commerce.order.purchase.DardenDigitalWalletBean",
                //           ...googlePayPayment,
                //           sdkVersion: "ECv1",
                //         },
                //         authTransID: "",
                //         status: "SUCCESS",
                //         ...dfpParams,
                //       };
                //     }
                //     return null;
                //   }),
                // }


                _context8.next = 6;
                return this.axios.post(this.config.postfix.SUBMIT_ORDER, submitOrderRequest, {
                  params: {
                    locale: locale
                  },
                  headers: headers
                }).then(function (response) {
                  return response.data.response;
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 6:
                return _context8.abrupt("return", _context8.sent);

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function submitOrder(_x10, _x11) {
        return _submitOrder.apply(this, arguments);
      }

      return submitOrder;
    }()
  }, {
    key: "clearCart",
    value: function () {
      var _clearCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(jwtToken, clearCartPayload) {
        var headers;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                _context9.next = 4;
                return this.axios.put(this.config.postfix.CLEAR_CART, clearCartPayload, {
                  headers: headers
                }).then(function (response) {
                  return response.data;
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 4:
                return _context9.abrupt("return", _context9.sent);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function clearCart(_x12, _x13) {
        return _clearCart.apply(this, arguments);
      }

      return clearCart;
    }()
  }, {
    key: "transformPaymentPayload",
    value: function transformPaymentPayload(payment, dfpParams) {
      if (payment.creditCard) {
        var _payment$creditCard$b, _payment$creditCard$b2, _payment$creditCard$b3, _payment$creditCard$b4;

        var defaultCard = payment.creditCard["default"];
        delete payment.creditCard["default"];
        var isVaulted = payment.creditCard.isVaulted;
        delete payment.creditCard.isVaulted;
        var saveCardToProfile = payment.creditCard.saveCardToProfile;
        var saveCardParams = saveCardToProfile ? {
          updateSavedCardMandate: payment.creditCard.updateSavedCardMandate,
          acceptClientType: payment.creditCard.acceptClientType,
          acceptConceptCode: this.config.getConceptCode(),
          saveCardToProfile: true
        } : {};
        delete payment.creditCard.saveCardToProfile;
        var cardOnFileFlag = saveCardToProfile || isVaulted ? {
          cardOnFile: true
        } : {
          cardOnFile: false
        };
        return _objectSpread(_objectSpread(_objectSpread({}, payment), cardOnFileFlag), {}, {
          makePayment: isVaulted ? true : false,
          validateBillingAddress: (_payment$creditCard$b = payment.creditCard.billingAddress) !== null && _payment$creditCard$b !== void 0 && _payment$creditCard$b.address1 && (_payment$creditCard$b2 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b2 !== void 0 && _payment$creditCard$b2.postalCode && (_payment$creditCard$b3 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b3 !== void 0 && _payment$creditCard$b3.firstName && (_payment$creditCard$b4 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b4 !== void 0 && _payment$creditCard$b4.lastName ? true : false,
          transType: "TGC",
          "default": defaultCard,
          creditCard: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
            "atg-rest-class-type": "com.darden.commerce.order.purchase.CreditCardBean"
          }, payment.creditCard), {}, {
            billingAddress: _objectSpread({
              "atg-rest-class-type": "atg.core.util.Address"
            }, payment.creditCard.billingAddress)
          }, payment.creditCard.paymentCVV ? {
            paymentCVVEnabled: true
          } : {}), dfpParams), saveCardParams),
          authTransID: "",
          status: "SUCCESS"
        });
      }

      return null;
    }
  }, {
    key: "giftCardSubmitOrder",
    value: function () {
      var _giftCardSubmitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(orderId, gcSubmitOrderRequest) {
        var _this = this,
            _response$data2;

        var commonQueryParams, locale, payments, dfpParams, paymentAlreadyProcessed, response, successResp;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                payments = gcSubmitOrderRequest.payments;
                delete gcSubmitOrderRequest.payments;
                dfpParams = gcSubmitOrderRequest.bamsCorrelationId ? {
                  correlationId: gcSubmitOrderRequest.bamsCorrelationId,
                  customerLocalDate: getLocalISODateString(moment().toDate())
                } : {};
                delete gcSubmitOrderRequest.bamsCorrelationId;
                paymentAlreadyProcessed = gcSubmitOrderRequest.paymentAlreadyProcessed ? "true" : "false";
                _context10.next = 9;
                return this.axios.post(this.config.postfix.GC_SUBMIT_ORDER, {
                  gcSubmitOrderRequest: gcSubmitOrderRequest,
                  paymentAlreadyProcessed: paymentAlreadyProcessed,
                  locale: locale,
                  paymentCollection: {
                    "atg-rest-class-type": "java.util.ArrayList",
                    "atg-rest-class-descriptor": {
                      "atg-rest-values": {
                        "container-class": "java.util.ArrayList",
                        "element-class": "com.darden.integration.paymentservice.bean.TransactionalDetail"
                      }
                    },
                    "atg-rest-values": payments.map(function (payment) {
                      return _this.transformPaymentPayload(payment, dfpParams);
                    })
                  }
                });

              case 9:
                response = _context10.sent;
                successResp = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.successResponse;

                if (!successResp) {
                  _context10.next = 15;
                  break;
                }

                return _context10.abrupt("return", successResp === null || successResp === void 0 ? void 0 : successResp.order);

              case 15:
                throw new ErrorResponse({
                  fault: [{
                    faultCode: "SubmitOrderFail",
                    faultDescription: ""
                  }]
                });

              case 16:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function giftCardSubmitOrder(_x14, _x15) {
        return _giftCardSubmitOrder.apply(this, arguments);
      }

      return giftCardSubmitOrder;
    }()
  }, {
    key: "setCateringDeliveryPartySize",
    value: function setCateringDeliveryPartySize(_request) {
      var commonQueryParams = this.config.getCommonQueryParams();
      var locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
      var request = _request ? _objectSpread(_objectSpread({}, _request), {}, {
        locale: locale
      }) : {};
      return this.axios.put(this.config.postfix.SET_DELIVERY_PARTY_SIZE, request);
    }
  }, {
    key: "submitDineInOrder",
    value: function () {
      var _submitDineInOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(submitOrderRequest, jwtToken) {
        var headers;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                _context11.next = 4;
                return this.axios.post(this.config.postfix.SUBMIT_ORDER, _objectSpread({}, submitOrderRequest), {
                  headers: headers
                }).then(function (response) {
                  var _response$data3;

                  return (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.response;
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 4:
                return _context11.abrupt("return", _context11.sent);

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function submitDineInOrder(_x16, _x17) {
        return _submitDineInOrder.apply(this, arguments);
      }

      return submitDineInOrder;
    }()
  }, {
    key: "applyBagFee",
    value: function () {
      var _applyBagFee = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(payload, jwtToken) {
        var commonQueryParams, locale, headers;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                _context12.next = 6;
                return this.axios.post(this.config.postfix.APPLY_BAG_FEE, payload, {
                  params: {
                    locale: locale
                  },
                  headers: headers
                }).then(function (response) {
                  return response === null || response === void 0 ? void 0 : response.data;
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 6:
                return _context12.abrupt("return", _context12.sent);

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function applyBagFee(_x18, _x19) {
        return _applyBagFee.apply(this, arguments);
      }

      return applyBagFee;
    }()
  }, {
    key: "removeBagFee",
    value: function () {
      var _removeBagFee = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(orderId, jwtToken) {
        var commonQueryParams, locale, headers;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                _context13.next = 6;
                return this.axios["delete"](this.config.postfix.REMOVE_BAG_FEE, {
                  params: {
                    locale: locale,
                    orderId: orderId
                  },
                  headers: headers
                }).then(function (response) {
                  return response === null || response === void 0 ? void 0 : response.data;
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 6:
                return _context13.abrupt("return", _context13.sent);

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function removeBagFee(_x20, _x21) {
        return _removeBagFee.apply(this, arguments);
      }

      return removeBagFee;
    }()
  }, {
    key: "updateDeliveryCookie",
    value: function () {
      var _updateDeliveryCookie = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(orderId, jwtToken) {
        var commonQueryParams, locale, headers;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                _context14.next = 6;
                return this.axios.put(this.config.postfix.UPDATE_DELIVERY_COOKIE, {
                  params: {
                    locale: locale,
                    orderId: orderId
                  },
                  headers: headers
                }).then(function (response) {
                  return response === null || response === void 0 ? void 0 : response.data;
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 6:
                return _context14.abrupt("return", _context14.sent);

              case 7:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function updateDeliveryCookie(_x22, _x23) {
        return _updateDeliveryCookie.apply(this, arguments);
      }

      return updateDeliveryCookie;
    }()
  }]);

  return Cart;
}();

export { Cart as default };